/**
 * Validate if the value entered is CPF or CNPJ
 * @param {string|integer} value supposed cpf|cnpj (can be string or integer)
 *
 * @return {boolean}
 */
const validateCPFCNPJ = (value) => {

  if (value == "" || value == null) {
    return false;
  }

  // Convert to string and leave only numbers
  value = value.toString();
  value = value.replace(/[^0-9]/g, '');

  var type = verify_cpf_cnpj(value);

  return validate_cpf_cnpj(value, type);
};

export default validateCPFCNPJ;

/**
 * Verify if value is CPF or CNPJ
 *
 * @param {string} value CPF or CNPJ number.
 * @return {string} Returns what type does the number refer to.
 */
function verify_cpf_cnpj (value) {
  // Verify CPF
  if ( value.length === 11 ) {
      return 'CPF';
  }

  // Verify CNPJ
  else if ( value.length === 14 ) {
      return 'CNPJ';
  }

  return false;
}

/**
 * Multiply digits x positions
 *
 * @param {string} digits the number digits.
 * @param {string|integer} [positions] The position that will start the regression
 * @param {integer} [sum_digits] The sum of multiplications between positions and digits
 *
 * @return {string} Digits sent concatenated with the last digit
 */
function calc_digits_positions( digits, positions = 10, sum_digits = 0 ) {

  // Make the sum digits with the position
  // Ex. to 10 positions:
  //   0    2    5    4    6    2    8    8   4
  // x10   x9   x8   x7   x6   x5   x4   x3  x2
  //   0 + 18 + 40 + 28 + 36 + 10 + 32 + 24 + 8 = 196
  for ( let i = 0; i < digits.length; i++  ) {

      sum_digits = sum_digits + ( digits[i] * positions );

      positions--;

      // To CNPJ set position at 9
      if ( positions < 2 ) {
          positions = 9;
      }
  }

  // Capture or remainder of division between sum digits divided by 11
  // Ex.: 196 % 11 = 9
  sum_digits = sum_digits % 11;

  // Checks if sum_digits is less than 2
  if ( sum_digits < 2 ) {
      sum_digits = 0;
  } else {
      // If greater than 2, the result is 11 minus sum_digits
      // Ex.: 11 - 9 = 2
      // Our wanted digit is 2
      sum_digits = 11 - sum_digits;
  }

  // Concatenates one more digit to the first nine digits
  // Ex.: 025462884 + 2 = 0254628842
  var number = digits + sum_digits;

  return number;
}

/**
 * Validate CPF
 *
 * @param {string} value The CPF number.
 * @param {string} type Define the type number (CPF|CNPJ)
 *
 * @return {boolean} Returns if is CPF.
 */
function validate_cpf_cnpj (value, type) {

  if (type == 'CPF') {
    let errors = [
      '00000000000',
      '11111111111',
      '22222222222',
      '33333333333',
      '44444444444',
      '55555555555',
      '66666666666',
      '77777777777',
      '88888888888',
      '99999999999'
    ];

    if (errors.findIndex((x) => x === value) != -1) {
      return false;
    }

    var firstNumbers = 9, firstCalcPosition = 10, secondCalcPosition = 11;
  }
  else if (type == 'CNPJ') {
    var firstNumbers = 12, firstCalcPosition = 5, secondCalcPosition = 6;
  }
  else {
    return false;
  }

  // Get the first CPF|CNPJ numbers
  var digits = value.substr(0, firstNumbers);

  // Calculates the first (9|12) digits of the CPF|CNPJ to obtain the first digit
  var comparator = calc_digits_positions(digits, firstCalcPosition);

  // Calculates the (10|5) digits of the CPF|CNPJ to obtain the last digit
  var comparator = calc_digits_positions( comparator, secondCalcPosition);

  if (comparator === value) {
    return true;
  }

  return false;
}



// WEBPACK FOOTER //
// ./resources/office/js/helpers/cpf-cnpj-validator.js